


























import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import ImagePreview from "@/components/ImagePreview";

export default defineComponent({
  name: "PersonalIdExampleConfirm",
  components: { BaseConfirm, BaseButton, ImagePreview },
  props: {
    showExampleModal: { type: Boolean, default: false },
  },
});
